import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation, useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ReportDashboard from '../components/ReportDashboard';
import Disclaimer from '../components/Disclaimer';
import { getResearch, refreshResearch, createPersonnel } from '../api';

export default function ReportPage() {
  const { t } = useTranslation();
  const { slug } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { marketAlerts, loadList, startPolling } = useOutletContext();

  const [doc, setDoc] = useState(null);
  const [error, setError] = useState('');
  const cacheMessage = location.state?.cacheMessage || null;

  useEffect(() => {
    let active = true;
    setDoc(null); setError('');
    getResearch(slug)
      .then(d => { if (active) setDoc(d); })
      .catch(e => { if (active) setError(e.message); });
    return () => { active = false; };
  }, [slug]);

  const handleRefresh = async () => {
    try {
      await refreshResearch(slug);
      await loadList();
      startPolling(slug);
      navigate('/research');
    } catch (e) {
      setError(e.premiumRequired ? t('reportPage.errRefreshPremium') : e.message);
    }
  };

  const handlePersonClick = async (member, projectInfo) => {
    try {
      const { person } = await createPersonnel({
        name: member.name,
        role: member.role,
        project: projectInfo.project,
        projectSlug: projectInfo.projectSlug,
        basicBackground: member.background,
        basicCredibility: member.credibility,
      });
      navigate(`/personnel/${person.slug}`);
    } catch (e) { setError(e.message); }
  };

  if (error) return (
    <div className="report-section">
      <div className="error-msg">⚠️ {error}</div>
    </div>
  );
  if (!doc) return (
    <div className="report-section" style={{ padding: 40, textAlign: 'center', color: 'var(--text-muted)' }}>
      {t('reportPage.loading')}
    </div>
  );

  return (
    <div className="report-section">
      {cacheMessage && (
        <div className="cache-banner">💾 {cacheMessage}</div>
      )}
      <ReportDashboard
        doc={doc}
        onBack={() => navigate('/research')}
        onRefresh={handleRefresh}
        onPersonClick={handlePersonClick}
        marketAlerts={marketAlerts}
      />
      <Disclaimer />
    </div>
  );
}
